module.exports = {
  'canvas': require('./canvas'),
  'svg':    require('./svg')
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-scenegraph/src/render/index.js
// module id = 1528
// module chunks = 0